import styled, { keyframes } from 'styled-components/macro'

// Define the shimmer animation
const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`

interface SkeletonProps {
  width?: string | number
  height?: string | number
  margin?: string
  borderRadius?: string | number
}

const SkeletonElement = styled.div<SkeletonProps>`
  width: ${({ width }) => (typeof width === 'number' ? `${width}px` : width || '100%')};
  height: ${({ height }) => (typeof height === 'number' ? `${height}px` : height || '100%')};
  margin: ${({ margin }) => margin || '0'};
  border-radius: ${({ borderRadius }) =>
    borderRadius ? (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) : '8px'};
  background: linear-gradient(
    to right,
    ${({ theme }) => theme.backgroundModule} 8%,
    ${({ theme }) => theme.backgroundInteractive} 18%,
    ${({ theme }) => theme.backgroundModule} 33%
  );
  background-size: 800px 104px;
  animation: ${shimmer} 1.5s linear infinite forwards;
`

/**
 * Skeleton component for displaying loading states
 *
 * @param width - Width of the skeleton (number in px or string with units)
 * @param height - Height of the skeleton (number in px or string with units)
 * @param margin - CSS margin to apply around the skeleton
 * @param borderRadius - Border radius of the skeleton (number in px or string with units)
 */
export function Skeleton({ width = '100%', height = '100%', margin = '0', borderRadius = 8, ...rest }: SkeletonProps) {
  return <SkeletonElement width={width} height={height} margin={margin} borderRadius={borderRadius} {...rest} />
}
